import { ReactElement } from 'react'
import styled from 'styled-components'
import { Divider } from '@mui/material'
import { I18n } from 'common'
import { defaultTheme } from '../../../../../src/theme'
import { breakpoints } from '../../../../../src/theme/breakpoints'

interface OrderConfirmationVehicleHeaderProps {
  vehicleName: string
  personalNote: string
  customerName: string | undefined
  cartId: string | number | undefined
}

export const OrderConfirmationVehicleHeader = (
  props: OrderConfirmationVehicleHeaderProps
): ReactElement => {
  const { vehicleName, personalNote, customerName, cartId } = props
  return (
    <OrderConfirmationVehicleHeaderContainer>
      <OrderConfirmationVehicleTitle>
        {vehicleName}
      </OrderConfirmationVehicleTitle>
      <OrderConfirmationDetailsWrapper>
        <TextWrapper>
          <StyledText>
            <I18n name="cartID" />:{' '}
            <OrderConfirmationVehicleSubText>
              {cartId}
            </OrderConfirmationVehicleSubText>
          </StyledText>

          <DividerLine />

          <StyledText>
            <I18n name="customerName" />:{' '}
            <OrderConfirmationVehicleSubText>
              {customerName}
            </OrderConfirmationVehicleSubText>
          </StyledText>

          <DividerLine />

          <StyledText>
            <I18n name="personalNote" />:{' '}
            <OrderConfirmationVehicleSubText>
              {personalNote}
            </OrderConfirmationVehicleSubText>
          </StyledText>
        </TextWrapper>
      </OrderConfirmationDetailsWrapper>
    </OrderConfirmationVehicleHeaderContainer>
  )
}
const DividerLine = styled(Divider)`
  height: 24px;
  width: 1px;
  margin-left: 8px;
  margin-right: 8px;
  border-color: ${defaultTheme.colors.greyBorder};
  border-width: 1px;
  opacity: 1;
  orientation: vertical;

  @media screen and (max-width: ${breakpoints.tablet}px) {
    display: none;
  }
`
const OrderConfirmationVehicleHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  padding: 20px 24px;
`
const OrderConfirmationVehicleTitle = styled.div`
  font-family: 'Oswald';
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
`
const OrderConfirmationVehicleSubText = styled.span`
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  word-break: break-word;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  @media screen and (max-width: ${breakpoints.tablet}px) {
    flex-direction: column;
    font-weight: 800px;
    row-gap: 5px;
  }
`
const StyledText = styled.div`
  text-align: left;
  font: 'Roboto';
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  white-space: nowrap;

  ${OrderConfirmationVehicleSubText} {
    white-space: normal;
  }
`

const OrderConfirmationDetailsWrapper = styled.div`
  width: 100%;
`
